import { render, staticRenderFns } from "./ProbationApproval.vue?vue&type=template&id=05e85afe"
import script from "./ProbationApproval.vue?vue&type=script&lang=js"
export * from "./ProbationApproval.vue?vue&type=script&lang=js"
import style0 from "./ProbationApproval.vue?vue&type=style&index=0&id=05e85afe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports